import React, { useRef, useCallback } from "react";
import svg144 from "../../../assets/svg/svg144.svg";
import svg145 from "../../../assets/svg/svg145.svg";
import svg146 from "../../../assets/svg/svg146.svg";
import svg147 from "../../../assets/svg/svg147.svg";
import svg148 from "../../../assets/svg/svg148.svg";
import { FaLinkedin } from "react-icons/fa6";
import svg41 from "../../../assets/svg/svg41.svg";
import PhoneInput from "react-phone-input-2";
import { Form, Input, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { isValidPhoneNumber } from "libphonenumber-js";
import toast from "react-hot-toast";
import SeoHead from "../../../components/SeoHead";
import { save } from "../../../features/auth/authSlice";

const { TextArea } = Input;

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const items = [
  {
    svg: svg144,
    title: "+254 705 672 576",
  },
  {
    svg: svg145,
    title: "business@ndovupay.org",
  },
  {
    svg: svg146,
    title: "Fair Acres, Hekima Road, Building 48, Nairobi, Karen",
  },
];

async function getCaptchaToken(action) {
  return new Promise((resolve, reject) => {
    window.grecaptcha.enterprise.ready(async () => {
      try {
        const token = await window.grecaptcha.enterprise.execute(SITE_KEY, { action });
        resolve(token);
      } catch (e) {
        reject(e);
      }
    });
  });
}

function Contact() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.auth);

  const onFinish = useCallback(async (values) => {
    let captchaToken;
    try {
      captchaToken = await getCaptchaToken("CONTACT_INQUIRY");
    } catch {
      toast.error("reCAPTCHA not ready. Please try again.");
      return;
    }

    const res = await dispatch(save({
      ...values,
      captchaToken,
      url: "api/v1/contact-inquiry/save-contact-inquiry",
    }));
    if (res?.payload?.success) {
      toast.success(res?.payload?.messages?.message);
      form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  }, [dispatch, form]);

  return (
    <div className='mt-[5rem] flex items-center justify-center  bg-img-2 h-auto lg:py-[10rem] py-3 lg:px-0 px-3'>
      <SeoHead
        title="Contact Us"
        description="Get in touch with NdovuPay. Reach us via phone, email or the contact form and our team will get back to you promptly."
        path="/contact"
      />

      <div className="flex gap-[5.75rem] lg:flex-row flex-col ">
        <div className="flex flex-col">
          <div className="flex items-center text-[#000] font-interSans text-[3rem] font-[400]">
            Lets Get in
            <span className="font-[700] text-ndovuRed">Touch!</span>
          </div>
          <div className="mt-[.5rem] lg:max-w-[35rem] w-full text-[#1A1A1A] text-[1rem] font-[400] leading-[1.625rem]">
            Have a question or need assistance? Reach out to us via the contact
            form below, email, or phone. We're eager to assist you.
          </div>
          <div className="mt-[1.75rem] flex flex-col gap-y-[1rem]">
            {items &&
              items?.map((item, index) => (
                <div key={index} className="flex items-center gap-[0.75rem]">
                  <img
                    src={item?.svg}
                    alt={item?.title}
                    className="w-[1.5rem] h-[1.5rem]"
                  />
                  <span className="text-[#1A1A1A] text-[0.875rem] font-[400]">
                    {item?.title}
                  </span>
                </div>
              ))}
          </div>
          <div className="mt-[1rem] flex items-center gap-[1.25rem]">
            <a href="https://www.facebook.com/ndovupay/" target="_blank" rel="noopener noreferrer">
              <img src={svg147} alt="facebook" />
            </a>
            <a href="https://wa.me/254705672576" target="_blank" rel="noopener noreferrer">
              <img src={svg148} alt="whatsapp" />
            </a>
            <a href="https://www.linkedin.com/company/ndovupay/?viewAsMember=true" target="_blank" rel="noopener noreferrer">
              <FaLinkedin size={24} />
            </a>
          </div>
          <div className="mt-[3.94rem] flex items-center text-center lg:blok hidden">
            <img src={svg41} alt="svg41" />
          </div>
        </div>
        <div className="flex-1 w-full">
          <Form
        layout="vertical"
        ref={formRef}
        name="registration"
        onFinish={onFinish}
        scrollToFirstError
        form={form}
        className="lg:w-[28.05056rem] w-full"
      >
        <Form.Item
          label="Full Name"
          name="ciFullName"
          rules={[
            {
              required: true,
              message: "Full name is required",
            },
          ]}
        >
          <Input className="input" />
        </Form.Item>

        <Form.Item
          label="Phone Number:"
          name="ciPhone"
          validateFirst
          rules={[
            {
              required: true,
              message: "Phone number is required",
            },
            {
              validator: (_, value) => {
                if (!value) {
                  return Promise.reject(new Error("Phone number is required"));
                }
                const phoneWithPlus = value.startsWith("+")
                  ? value
                  : `+${value}`;
                if (isValidPhoneNumber(phoneWithPlus)) {
                  return Promise.resolve();
                }

                return Promise.reject(
                  new Error(
                    "Please enter a valid phone number for the selected country"
                  )
                );
              },
            },
          ]}
        >
          <PhoneInput
            enableSearch
            country="ke"
            countryCodeEditable={false}
            className="input"
          />
        </Form.Item>
        <Form.Item
          name="ciEmail"
          label="Email"
          rules={[
            {
              required: true,
              message: "Email is required to login",
            },
            {
              type: "email",
              message: "Please enter a valid email address",
            },
          ]}
        >
          <Input type="email" className="input" />
        </Form.Item>

        <Form.Item
          label="Reason"
          name="ciReason"
          rules={[
            {
              required: true,
              message: "Decline reason is required",
            },
          ]}
        >
          <TextArea rowSpins={5} className="text_area" />
        </Form.Item>

        <button
          className="cstm-btn-2 mt-[2rem] lg:!w-[14.5rem] w-auto"
          type="submit"
          disabled={saving}
        >
          {saving ? <Spin /> : "Inquire"}
        </button>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
